<template>
  <div class="common-input" :class="{ 'input-tip': tip }">
    <component
      :is="'s-' + type"
      v-model.trim="input_data"
      v-bind="$attrs"
      v-on="$listeners"
      @change="change"
      :placeholder="tip ? tip : $attrs.placeholder"
    ></component>
    <s-tooltip
      v-if="tip"
      :transfer="true"
      class="icon question-tip"
      :content="tip"
      placement="bottom"
    >
      &nbsp;
      <s-icon icon="question"></s-icon>
    </s-tooltip>
  </div>
</template>

<script>
export default {
  name: 'commonInput',
  props: {
    value: [Number, String],
    type: {
      type: String,
      default() {
        return 'input'
      },
    },
    tip: String,
  },
  data() {
    return {
      input_data: this.value,
    }
  },
  watch: {
    value(newVal) {
      this.input_data = this.value
    },
  },
  methods: {
    change(newVal) {
      let zero_width_char = ['\u200b', '\u200c', '\u200d', '\u200e', '\u200f', '\uFEFF'] // 部分零宽字符
      let reg = new RegExp(zero_width_char.join('|'), 'gi')
      if(newVal){
        this.input_data = newVal.replace(reg, '')
      }
      try {
        this.input_data = this.input_data.trim()
      } catch (e) {
        this.input_data = Number((this.input_data + '').trim())
      }
      this.$emit('input', this.input_data)

      if (this.$listeners.change) {
        this.$listeners.change(this.input_data)
      }
    },
  },
}
</script>

<style lang="stylus">
.input-tip
  position: relative;
  .tooltip
    position: absolute;
    right: 5px;
    top: 8px;
  .input-field input:not([type=radio]):not([type=checkbox])
    padding-right: 18px;
</style>
